import request from '@/utils/request'

export const getIndustries = () =>
  request({
    url: '/services_industries?per_page=100&page=1',
    method: 'get'
  })

  export const createIndustry = (data: any) =>
  request({
    url: '/industries',
    method: 'post',
    data
  })

  export const deleteIndustry = (data: any) =>
  request({
    url: '/industries',
    method: 'delete',
    data
  })
